export const USER_LIST_REQUEST      = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS      = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL         = 'USER_LIST_FAIL';

export const USER_DETAIL_REQUEST    = 'USER_DETAIL_REQUEST';
export const USER_DETAIL_SUCCESS    = 'USER_DETAIL_SUCCESS';
export const USER_DETAIL_FAIL       = 'USER_DETAIL_FAIL';